<child-header title="Partner Admin Relationship" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <div class="row">
      Admin relationship has been created successfully.
      <br />
      <br />
      <br />
    </div>


    <div class="row">
      <a style="width: 80%;" href="{{ data.link }}">
        {{ data.link }}
      </a>
      <a  class="basic-icon copy-icon" ngbTooltip="Copy Link" (click)="copyLink()">
      </a>
    </div>
    <div class="row">

    <br />
    <br />
    
      Please send the above link to customer end user who needs to accept this invitation as Dicker Data is their managing partner.
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-mid ok-button" (click)="okButton()">OK</button>
  </div>
</div>